import React, {Component} from 'react';
import {connect} from 'react-redux';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Brush} from 'recharts';
import * as dataService from "../service/data-info-chart/requestsUtil";
import {MONTHLY_RECOVERY, GRAPH_MARGIN, WHITOUT_INFORMATION, COLORS} from "../utils/constants";
import * as cbu from "../utils/checkBusinessUnit";
import * as formatter from "../utils/formatters"

var Loader = require('react-loader');

class MonthlyRecovery extends Component {

  constructor(props) {
    super(props);
    this.state = {datas: [], loaded: false, date:this.props.date};
  }

  componentDidMount() {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.state.date
    }

    dataService.postFetch(MONTHLY_RECOVERY, params)
      .then((data) => {
        this.setState({datas: data, loaded: true});
      });
  }

  componentWillReceiveProps(nextProps) {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.props.date
    }

    dataService.postFetch(MONTHLY_RECOVERY, params)
      .then((data) => {
        this.setState({datas: data, loaded: true, date:nextProps.date});
      });
  }

  render() {
    if (this.state.datas.length > 0) {
      return (
        <Loader loaded={this.state.loaded} top="90%">
          <ResponsiveContainer>
            <LineChart width={600} height={300} data={this.state.datas}
                       margin={GRAPH_MARGIN}>
              <XAxis dataKey="month"/>
              <YAxis tickFormatter={formatter.formatNumber} domain={[0, 'dataMax + 3000000']} scale={'linear'}/>
              <CartesianGrid/>
              <Tooltip formatter={formatter.formatNumberMoney}/>
              <Legend verticalAlign={"top"}/>
              <Line type="linear" name={"Meta"} dataKey="goal" stroke={COLORS.GOAL} strokeDasharray="5 5"/>
              <Line type="linear" name={"Monto"} dataKey="amount" stroke={COLORS.AMOUNT}/>
              <Line type="linear" name={"Base"} dataKey="base" stroke={COLORS.BASE}/>
              <Brush dataKey={"mes"} height={20}/>
            </LineChart>
          </ResponsiveContainer>
        </Loader>
      );
    } else {
      return (<Loader loaded={this.state.loaded} top="50%"><h2
        className="without-avilable-information">{WHITOUT_INFORMATION}</h2></Loader>);
    }
  }
}

// Connect linechartdata as props to compenent
function mapStateToProps(state) {
  return {
    lineChartData: state.monthlyRecovery
  }
}

export default connect(mapStateToProps)(MonthlyRecovery);




// WEBPACK FOOTER //
// ./src/charts/monthlyRecovery.js